import React, { Component } from 'react'
import { connect } from 'react-redux'

// API
import * as API  from '../../../utils/api'

// Packages
import update from 'immutability-helper'
import { Helmet } from 'react-helmet'

// Actions
import {
  updateForm,
} from '../../../actions/onboarding'

// Components
import SportForm from "./SportForm"
import AppCanvasLoader from '../../../components/Global/AppCanvasLoader'

// Utils
import { mathTrunc } from '../../../utils/helpers'

class SportSelection extends Component {

  state = {
    selectedSports: [
      {
        'id': {
          value: '',
          hasError: false,
        },
        'jersey_number': {
          value: '',
          hasError: false,
        },
        'positions': [
          {
            value: '',
            label: '',
            hasError: false
          }
        ]
      }
    ],
    sports: [],
    oneTimeFee: 0,
    displayErrorMessages: false,
    isLoading: true,
  }

  componentWillMount() {
    API.getOneTimeFee().then(response => {
      if (response.errors || response.error) {
        console.log('Error getting One Time Fee')
      } else {
        this.setState({
          oneTimeFee: response.price_in_dollars
        })
      }
    })
  }

  componentDidMount() {
    // Reset participations if they exist in Redux Store
    this.props.updateOnboardingForm({participations: []})

    this.setSports()
  }

  setSports() {
    // Load available sports from API
    API.getSports().then(sports => {
      let mensSports = sports.filter((sport) => {
        return sport.gender === 'Mens'
      })

      let womensSports = sports.filter((sport) => {
        return sport.gender === 'Womens'
      })

      this.setState({
        sports: mensSports.concat(womensSports),
        isLoading: false
      })
    })
  }

  // TO DO - Preload existing participations from Redux into SportForm's
  // The challenge here is that we weren't initially saving participations
  // to redux in the same structure that we're using to populate the forms.
  // Thus, we need to configure participations from Redux to correctly
  // populate any <SportForms>'s that are rendered
  // preloadExistingParticipations() {
  //   const { participations } = this.props.onboarding
  //   if (participations) {
  //     let initialSelectedSports = participations.map((object) => {
  //       return {
  //         'id': {
  //           value: object.participation.sport_id,
  //           hasError: false,
  //         },
  //         'jersey_number': {
  //           value: object.participation.jersey_number,
  //           hasError: false,
  //         },
  //         'positions': object.participation.primary_positions_id.map((idValue) => {
  //           return {
  //             value: idValue,
  //             label: '',
  //             hasError: false
  //           }
  //         })
  //       }
  //     })
  //   }
  // }

  handleSubmit = (event) => {
    event.preventDefault()

    if (this.isFormValid()) {
      let participations = this.getParticipations()
      const { activeProfile, onboarding } = this.props;

      // If there is an active profile set, that means that the profile does
      // not yet have any sports associated with it and needs the maintainer
      // to add sports.
      //
      // If no active profile, then the user is currently onboarding as usual.

      const profile = (
        activeProfile.first_name &&
        activeProfile.last_name &&
        activeProfile.username
      )
      ? {
        first_name: activeProfile.first_name,
        last_name: activeProfile.last_name,
        username: activeProfile.username,
      }
      : onboarding.maintained_profile;

      this.props.updateOnboardingForm({
        maintained_profile: profile,
        participations: participations
      });

      this.props.handleFormChange('plan-selection', 'sport-selection')
    } else {
      window.scrollTo(0, 0)
      this.setFormErrorState()
    }
  }

  getParticipations() {
    const { selectedSports } = this.state

    let participations = selectedSports.map((sport) => {
      return {
        participation: {
          jersey_number: sport.jersey_number.value,
          sport_id: parseInt(sport.id.value, 10),
          primary_position_ids: sport.positions.map((position) => {
            return parseInt(position.value, 10)
          })
        }
      }
    })

    return participations
  }

  isFormValid() {
    let { selectedSports } = this.state
    let formIsValid = []

    for (var sportObject of selectedSports) {
      for (let field of Object.keys(sportObject)) {
        if (field === 'positions') {
          for (var position of sportObject[field]) {
            if(!this.isFieldValid('position', position.value)) {
              formIsValid.push(false)
            }
          }
        } else {
          if (!this.isFieldValid(field, sportObject[field].value)) {
            formIsValid.push(false)
          }
        }
      }
    }

    if (formIsValid.indexOf(false) > -1) {
      return false
    } else {
      return true
    }
  }

  isFieldValid = (fieldName, value) => {
    switch(fieldName) {
      case 'position':
        return value ? value >= 0 : false
        // eslint-disable-next-line no-unreachable
        break
      case 'jersey_number':
        return true
        // eslint-disable-next-line no-unreachable
        break
      default:
        return value ? value.length > 0 : false
        // eslint-disable-next-line no-unreachable
        break
    }
  }

  setFormErrorState() {
    let newSelectedSports = [...this.state.selectedSports]

    // Cycle through each of the SportForms
    for (let [sportIndex, sportForm] of newSelectedSports.entries()) {

      // Loop through each field of a SportForm
      for (let field of Object.keys(sportForm)) {
        if (field === 'positions') {
          let positionsArray = sportForm['positions']

          // Loop through the array of position select inputs
          for (let [positionIndex, positionObject] of positionsArray.entries()) {
            let fieldValidity = this.isFieldValid('position', positionObject.value)

            // 1. Update the error state of the position select input
            const updatedPosition = update(positionObject, {
              hasError: {$set: !fieldValidity}
            })

            // 2. Splice the updated position object into the position array
            positionsArray = update(positionsArray, {
              $splice: [[positionIndex, 1, updatedPosition]]
            })

            // 3. Update the Positions Array of the Current Sport Object
            newSelectedSports[sportIndex].positions = positionsArray

            const updatedSport = newSelectedSports[sportIndex]

            // 4. Splice updated sport object back into selectedSports array
            newSelectedSports = update(newSelectedSports, {
              $splice: [[sportIndex, 1, updatedSport]]
            })
          }
        } else {
          let fieldValidity = this.isFieldValid(field, sportForm[field].value)

          // 1. Update the current field in the sport object
          const updatedSport = update(newSelectedSports[sportIndex], {
            [field]:{hasError: {$set: !fieldValidity}}
          })

          // 2. Splice updated sport object back into selectedSports array
          newSelectedSports = update(newSelectedSports, {
            $splice: [[sportIndex, 1, updatedSport]]
          })
        }
      }

    }

    this.setState(state => ({
      ...state,
      selectedSports: newSelectedSports
    }))
  }

  addSport = (event) => {
    event.preventDefault()

    let newSportObject =  {
      'id': {
        value: '',
        hasError: false,
      },
      'jersey_number': {
        value: '',
        hasError: false,
      },
      'positions': [
        {
          value: '',
          label: '',
          hasError: false
        }
      ]
    }

    // Update the state with the modified selectedSport
    this.setState(state => ({
      ...state,
      selectedSports: [
        ...state.selectedSports,
        newSportObject
      ]
    }))
  }


  removeSport = (event, sportIndex) => {
    event.preventDefault()

    let selectedSports = [...this.state.selectedSports]

    let newState = selectedSports.filter((sport, index) => {
      return index !== sportIndex
    })

    this.setState(state => ({
      ...state,
      selectedSports: newState
    }))
  }

  addPositionToSport = (sportIndex) => {
    let selectedSports = [...this.state.selectedSports]

    let newPosition = {
      value: '',
      label: '',
      hasError: false,
    }

    selectedSports[sportIndex].positions.push(newPosition)

    let updatedSport = selectedSports[sportIndex]

    const newSelectedSportsState = update(selectedSports, {
      $splice: [[sportIndex, 1, updatedSport]]
    })

    this.setState(state => ({
      ...state,
      selectedSports: newSelectedSportsState
    }))
  }

  removePositionFromSport = (sportIndex, positionSelectorIndex) => {
    let newSelectedSports = [...this.state.selectedSports]
    let newPositions = [...newSelectedSports[sportIndex].positions]

    newPositions = [
      ...newPositions.slice( 0, positionSelectorIndex ),
      ...newPositions.slice( positionSelectorIndex + 1, newPositions.length)
    ]

    newSelectedSports[sportIndex].positions = newPositions

    this.setState(state => ({
      ...state,
      selectedSports: newSelectedSports
    }))
  }


  handleInputChange = (event, sportIndex) => {
    const { value, name } = event.target

    if(name === 'id') {
      this.resetSport(value, sportIndex)
    } else {
      const selectedSports = [...this.state.selectedSports]
      const updatedSport = update(selectedSports[sportIndex], {
        [name]:{value: {$set: value}, hasError: {$set: false}}
      })

      const newSelectedSportsState = update(selectedSports, {
        $splice: [[sportIndex, 1, updatedSport]]
      })

      this.setState(state => ({
        ...state,
        selectedSports: newSelectedSportsState
      }))
    }
  }

  resetSport = (sportId, sportIndex) => {
    const selectedSports = [...this.state.selectedSports]

    let newSportObject =  {
      'id': {
        value: sportId,
        hasError: false,
      },
      'jersey_number': {
        value: '',
        hasError: false,
      },
      'positions': [
        {
          value: '',
          label: '',
          hasError: false
        }
      ]
    }

    const newSelectedSportsState = update(selectedSports, {
      $splice: [[sportIndex, 1, newSportObject]]
    })

    this.setState(state => ({
      ...state,
      selectedSports: newSelectedSportsState
    }))
  }


  handlePositionSelectChange = (event, selectOptions, sportIndex, positionIndex) => {
    let { value } = event.target
    let selectedSports = [...this.state.selectedSports]

    /////////////////////////////////////////////////
    // Update Array of Selected Sport Positions
    let newSelectedPositionsState = [...selectedSports[sportIndex].positions]

    let selectedPosition = selectOptions.filter((option) => {
      return parseInt(option.value, 10) === parseInt(value, 10)
    })

    selectedPosition[0].hasError = false

    newSelectedPositionsState[positionIndex] = selectedPosition[0]
    /////////////////////////////////////////////////


    const updatedSelectedSport = update(selectedSports[sportIndex], {
      positions: {$set: newSelectedPositionsState}
    })

    // Splice this updated selected sport into the
    // selected sports state
    const newSelectedSportsState = update(selectedSports, {
      $splice: [[sportIndex, 1, updatedSelectedSport]]
    })

    this.setState(state => ({
      ...state,
      selectedSports: newSelectedSportsState
    }))
  }

  renderSportForms = () => {
    const { displayErrorMessages, selectedSports } = this.state
    const { sports } = this.state

    return sports.length > 0
    ? (
      selectedSports.map((selectedSport, index) => {
        return (
          <SportForm
            key={selectedSport + index}
            ref={'sportForm' + index}
            formNumber={index + 1}
            sports={sports}
            indexInParent={index}
            selectedSport={selectedSport}
            handleInputChange={this.handleInputChange}
            updatePositionSelection={this.handlePositionSelectChange}
            handlePositionAddition={this.addPositionToSport}
            handlePositionRemoval={this.removePositionFromSport}
            displayErrorMessages={displayErrorMessages}
            removeSport={this.removeSport}
          />
        )
      })
    ) : null
  }

  renderFormStep() {
    const { role } = this.props.user

    return role === 'parent'
    ? ( <p> Step 4 of 5 </p> )
    : ( <p> Step 3 of 4 </p> )
  }

  getOneTimeFee() {
    return this.state.oneTimeFee
  }

  getOneTimeFeeDollars = () => {
    return mathTrunc(this.state.oneTimeFee)
  }

  getOneTimeFeeCents = () => {
    let cents = this.state.oneTimeFee
    cents = String(cents).split(".")[1]
    if (cents !== "00") {
      return "." + cents
    }
  }
  getAnnualFeeTotal() {
    let numberOfSports = this.state.selectedSports.length
    let totalDollars = this.getOneTimeFeeDollars() + (99 * numberOfSports)
    let cents = this.getOneTimeFeeCents()
    if (cents === undefined) {
      return totalDollars
    } else {
      return totalDollars + cents
    }
  }

  render() {
    const { appName } = this.props
    const { isLoading } = this.state

    return isLoading
    ? (<AppCanvasLoader/>)
    : (
      <div className="onboarding-sport-selection">
        <Helmet>
          <title>{appName} | Select Sports</title>
        </Helmet>
        <header>
          {this.renderFormStep()}
          <h2>Select Sports</h2>
          <p>
            Select the sport(s) you want to add to your athlete profile. The first sport selected will be your primary sport.
          </p>
        </header>
        <form onSubmit={this.handleSubmit}>
          {this.renderSportForms()}
          <div className="onboarding-sport-selection-add-sport">
            <a
              className="cta"
              onClick={ (event) => this.addSport(event)}
            >
              + Add Another Sport
            </a>
          </div>
          <input
            className="cta-gradient"
            type="submit"
            value="Continue"
            onClick={this.handleSubmit}
          />
        </form>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    onboarding: state.onboarding,
    user: state.user,
    activeProfile: state.activeProfile,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    updateOnboardingForm: formData => {
      dispatch(updateForm(formData))
    },
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SportSelection)



// WEBPACK FOOTER //
// ./src/screens/Onboarding/Forms/SportSelection.js